import type { ObjectMetadata } from '@olytic/foundation';

import { formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDateTime, column, createdByField, field, lastModifiedByField, type Row, related, show, text } from './kit';

const def = OBJECT_DEFS['resource-roles'];
const share = show((v) => `${formatNumber(v)}%`);

/** A kind of delivery work. Rationale: resource-roles.md. */
export const resourceRoles: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Delivery role',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('name', 'Name'),
    field('active', 'Active', { format: asCheck }),
    field('description', 'Description', { wide: true }),
    field('sort_order', 'Order', { format: show((v) => formatNumber(v)) }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['name', 'active'] },
    { key: 'description', label: 'Description', fields: ['description'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['sort_order', 'created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [
    related('people', 'People', 'user-resource-roles', [
      column('name', 'Person', { primary: true }),
      column('is_primary', 'Primary'),
    ]),
    related('role-shares', 'Products It Staffs', 'product-resource-roles', [
      column('name', 'Product', { primary: true }),
      column('share_pct', 'Share of Hours', { format: share, align: 'right' }),
    ]),
  ],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'description'],
};
